import { txt } from 'libs/i18n';
export const getAiError = (error) => {
    let errorMessage;
    switch (error) {
        case 'input-text-is-empty':
            errorMessage = txt('inputTextIsEmpty');
            break;
        case 'project-not-found':
            errorMessage = txt('projectNotFound');
            break;
        case 'project-has-no-transcription':
            errorMessage = txt('projectHasNoTranscription');
            break;
        case 'missing-project-id':
            errorMessage = txt('missingProjectId');
            break;
        case 'invalid-format':
            errorMessage = txt('invalidFormat');
            break;
        case 'invalid-structure':
            errorMessage = txt('invalidStructure');
            break;
        case 'invalid-value':
            errorMessage = txt('invalidValue');
            break;
        case 'quota-exceeded':
            errorMessage = txt('quotaExceeded');
            break;
        case 'rate-limit-reached':
            errorMessage = txt('rateLimitReached');
            break;
        case 'content-filtered':
            errorMessage = txt('contentFiltered');
            break;
        case 'invalid-request':
            errorMessage = txt('invalidRequest');
            break;
        case 'unauthorized':
            errorMessage = txt('unauthorized');
            break;
        case 'forbidden':
            errorMessage = txt('forbidden');
            break;
        case 'request-too-large':
            errorMessage = txt('requestTooLarge');
            break;
        case 'api-overload':
            errorMessage = txt('apiOverload');
            break;
        case 'tokens-exceeded':
            errorMessage = txt('tokensExceeded');
            break;
        case 'unknown-finish-reason':
            errorMessage = txt('unknownFinishReason');
            break;
        case 'unknown-error':
            errorMessage = txt('unknownError');
            break;
        default:
            errorMessage = txt('unexpectedError');
    }
    return errorMessage;
};
